<ng-container *ngIf="entry">
  <udex-button
    *ngIf="showPricingTooltip && (pricePerLicenseData || priceCalculationBreakdownData || entry.totalPrice.value)"
    class="price-details__button" size="Medium"
    icon="sap-icon://message-information" design="Tertiary"
    (keydown.enter)="openPriceDisplayModal()"
    (click)="openPriceDisplayModal()"
    accessible-name="priceDetailsTooltip"
    accessible-role="Button"
  ></udex-button>
  <span class="price-details__heading heading__regular--xxxs udex-ms-2">
    {{ dcpOrderEntryService.getSubtotalByCode(entry, this.entry.product.code) }}
  </span>

  <ng-template #modalContentTemplate class="price-details-modal">
    <div content
         class="price-details-modal__content">
      <ng-container *ngIf="pricePerLicenseData">
        <h3 class="price-details-modal__heading heading__medium--xxxxs udex-mb-8">
          {{ 'cartItems.priceTooltip.per.header' | cxTranslate }}</h3>
        <table class="price-details-modal__table w-100 body--xs">
          <tr class="price-details-modal__table-row d-none d-sm-flex flex-sm-row justify-content-between">
            <th class="body--xs udex-px-0 udex-py-sm-8">
              <span
                class="price-details-modal__table-header">{{ 'cartItems.priceTooltip.per.licenseMaterial' | cxTranslate }}</span>
            </th>
            <th class="body--xs udex-px-0 udex-py-sm-8">
              <span
                class="price-details-modal__table-header">{{ 'cartItems.priceTooltip.per.quantity' | cxTranslate }}</span>
            </th>
            <th class="body--xs udex-px-0 udex-py-sm-8">
              <span
                class="price-details-modal__table-header">{{ 'cartItems.priceTooltip.per.pricePer' | cxTranslate }}</span>
            </th>
          </tr>
          <tr class="price-details-modal__table-row d-flex flex-sm-row justify-content-between">
            <td class="udex-px-0 body--xs d-flex flex-column">
              <span
                class="price-details-modal__table-header udex-mt-4 d-sm-none">{{ 'cartItems.priceTooltip.per.licenseMaterial' | cxTranslate }}</span>
              <span class="price-details-modal__table-text udex-mt-4 udex-mt-sm-8">{{ pricePerLicenseData.name }}</span>
            </td>
            <td class="udex-px-0 body--xs d-flex flex-column">
              <span
                class="price-details-modal__table-header udex-mt-4 d-sm-none">{{ 'cartItems.priceTooltip.per.quantity' | cxTranslate }}</span>
              <dcp-metric-text class="price-details-modal__table-text" [quantity]="entry.quantity"
                               [product]="entry.product"></dcp-metric-text>
            </td>
            <td class="udex-px-0 body--xs d-flex flex-column">
              <span
                class="price-details-modal__table-header d-sm-none">{{ 'cartItems.priceTooltip.per.pricePer' | cxTranslate }}</span>
              <span
                class="price-details-modal__table-text udex-mt-4 udex-mt-sm-8">{{ pricePerLicenseData.pricePer }}</span>
            </td>
          </tr>
        </table>
      </ng-container>
      <ng-container *ngIf="priceCalculationBreakdownData">
        <h3 class="price-details-modal__heading content__heading heading__medium--xxxxs udex-mt-32 udex-mb-8">
          {{ 'cartItems.priceTooltip.breakdown.header' | cxTranslate }}</h3>
        <table class="price-details-modal__breakdown-table w-100 body--xs">
          <tr class="price-details-modal__table-row d-none d-sm-flex flex-sm-row justify-content-between">
            <th class="udex-py-sm-8 body--xs ">
              <span
                class="price-details-modal__table-header">{{ 'cartItems.priceTooltip.breakdown.duration' | cxTranslate }}</span>
            </th>
            <th class="udex-py-sm-8 body--xs ">
              <span
                class="price-details-modal__table-header">{{ 'cartItems.priceTooltip.breakdown.cost' | cxTranslate }}</span>
            </th>
          </tr>
          <ng-container *ngFor="let breakdown of priceCalculationBreakdownData">
            <tr class="price-details-modal__table-row d-flex flex-sm-row justify-content-between">
              <td class="price-details-modal__table-text d-flex flex-column udex-px-0">
                <span
                  class="price-details-modal__table-header d-sm-none udex-mt-4">{{ 'cartItems.priceTooltip.breakdown.duration' | cxTranslate }}</span>
                <span class="price-details-modal__table-text udex-mt-4 udex-my-sm-8">{{ breakdown.startDate | dcpDate }}
                  - {{ breakdown.endDate | dcpDate }}</span>
              </td>
              <td class="price-details-modal__table-text d-flex flex-column udex-px-0">
                <span
                  class="price-details-modal__table-header d-sm-none udex-mt-4">{{ 'cartItems.priceTooltip.breakdown.cost' | cxTranslate }}</span>
                <span
                  class="price-details-modal__table-text udex-mt-4 udex-my-sm-8">{{ breakdown.formattedValues.totalValue }}</span>
              </td>
            </tr>
          </ng-container>
        </table>
      </ng-container>
      <ng-container *ngIf="entry.totalPrice.value">
        <div class="price-details-modal__total d-flex flex-column align-items-end align-items-sm-end"
             *ngIf="$transactionTypeTexts | async as transactionTypeTexts; else defaultSubheading"
        >
          <div class="price-details-modal__total-headings w-100 d-flex justify-content-between flex-row udex-mt-32">
            <p class="price-details-modal__total-heading heading__regular--xxxs">
              {{ 'cartItems.priceTooltip.subtotal.title' | cxTranslate }}
            </p>
            <p class="price-details-modal__total-heading heading__medium--xxxs text-end">
              {{ dcpOrderEntryService.getSubtotalByCode(entry, entry?.product?.code) }}
            </p>
          </div>
          <span class="price-details-modal__total-text body--xs udex-mt-8 udex-mt-sm-12"
                *ngIf="transactionTypeTexts.priceSubheading">{{ transactionTypeTexts.priceSubheading }}
          </span>
          <span class="price-details-modal__total-text body--xs udex-mt-4"
                *ngIf="transactionTypeTexts.priceSubheading2">{{ transactionTypeTexts.priceSubheading2 }}
          </span>
        </div>

        <ng-template #defaultSubheading>
          <p class="price-details-modal__total-heading heading__medium--xs udex-mt-32 text-end">
            {{ dcpOrderEntryService.getSubtotalByCode(entry, entry?.product?.code) }}</p>
          <p class="price-details-modal__total-text body--xs udex-mt-8  udex-mt-sm-12 text-end">
            {{ 'cartItems.priceTooltip.subtotal.taxCalculated' | cxTranslate }}</p>
          <p class="price-details-modal__total-text body--xs udex-mt-4 text-end">
            {{ 'cartItems.priceTooltip.subtotal.existingPricing' | cxTranslate }}</p>
        </ng-template>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
